import "./BachatPage.css";
import BachatData from "../../temp/bachat-page.json";
import Footer from "../../components/Footer/Footer";

function BachatPage() {
  return (
    <div className="bachat-page">
      <div className="bachat-page__content">
        <div>
          <h3>बचत का प्रकार हरु </h3>
          {BachatData.data.map((el) => {
            return (
              <div key={el.id} className="bachat-page__bachat-item">
                <h4>{el.name}</h4>: &nbsp; <p>{el.value}</p>
              </div>
            );
          })}
        </div>
        <div>
          <h3>आवाधिक बचत का प्रकार हरु </h3>
          {BachatData.awadthikBachat.map((el) => {
            return (
              <div key={el.id} className="bachat-page__bachat-item">
                <h4>{el.name}</h4>: &nbsp; <p>{el.value}</p>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BachatPage;
